// import type { BloodGlucoseDataPoint } from "~/api/bloodGlucose";

type TimeRange = "1d" | "7d" | "1m" | "6m" | "1y";

interface UseBloodGlucoseCalculationsParams {
  filteredData: {
    date: string;
    low: number;
    high: number;
    avg: number;
    hour?: number;
    datetime?: string;
  }[];
  timeRange: TimeRange;
}

export const useBloodGlucoseCalculations = ({
  filteredData,
  timeRange,
}: UseBloodGlucoseCalculationsParams) => {
  // Calculate breakdown title based on time range and navigation offset
  const getBreakdownTitle = (): string => {
    if (filteredData.length === 0) {
      return "No Blood Glucose Data";
    }

    const firstItem = filteredData[0];
    const lastItem = filteredData[filteredData.length - 1];

    if (timeRange === "1d") {
      const firstHour = firstItem.hour ?? 0;
      const lastHour = lastItem.hour ?? 0;
      return `Hourly Blood Glucose (${firstHour}:00 - ${lastHour}:00)`;
    } else {
      const firstDate = new Date(firstItem.date);
      const lastDate = new Date(lastItem.date);

      if (timeRange === "7d") {
        return `Daily Blood Glucose (${firstDate.toLocaleDateString()} - ${lastDate.toLocaleDateString()})`;
      } else if (timeRange === "1m") {
        return `Daily Blood Glucose (${firstDate.toLocaleDateString("en-US", { month: "long", year: "numeric" })})`;
      } else if (timeRange === "6m") {
        return `Weekly Blood Glucose (${firstDate.toLocaleDateString("en-US", { month: "short", year: "numeric" })} - ${lastDate.toLocaleDateString("en-US", { month: "short", year: "numeric" })})`;
      } else if (timeRange === "1y") {
        return `Monthly Blood Glucose (${firstDate.getFullYear()})`;
      }
    }

    return "Blood Glucose Data";
  };

  return {
    breakdownTitle: getBreakdownTitle(),
  };
};
